module.exports = __webpack_public_path__ + "static/mockup-image-01-fa0ce3c8a1fe68df64b137544dd17572.jpg";